export const visGroupStyle = ({isSelected = false, hasDivider}) => {
  const borderColor = isSelected ? '#4f9bff' : 'transparent';
  const dividerStyle = 'border-top: 2px solid #000000';
  return `border-right: 5px solid ${borderColor}; `
    + 'width: 200px; '
    + `${hasDivider ? dividerStyle : ''}`;
};
